import { Navigate, useLocation } from 'react-router-dom';

/**
 * `/calendar/*` → `/publishing/*`, preserving the rest of the path, the query
 * string and the hash.
 *
 * The section renamed on 2026-08-23 because its URL and its own chrome
 * disagreed: every header, tab strip and `<title>` said "Publishing" while the
 * address bar said `calendar`. The old prefix cannot simply disappear — it is
 * in bookmarks, in agent-issued deep links, in report emails, and hardcoded in
 * `publish-failures.ts` remedies and `analytics/lenses/publishReliability.ts`.
 *
 * A WILDCARD, not an enumerated list: a route added under `/publishing` later
 * keeps working from the old prefix without anyone remembering to mirror it
 * here. `splat` is whatever followed `/calendar/`; an empty splat lands on the
 * section index, which redirects on to Calendar.
 */
export function PublishingLegacyRedirect() {
  const location = useLocation();
  const rest = location.pathname.replace(/^\/calendar\/?/, '');
  return (
    <Navigate
      to={{
        pathname: rest ? `/publishing/${rest}` : '/publishing',
        search: location.search,
        hash: location.hash,
      }}
      replace
    />
  );
}
